import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "welcome-message" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-military-green-500 pretitle" }, "Welcome to Skyline"),
  /*#__PURE__*/_createElementVNode("h3", { class: "-mt-3 font-bold text-rust-500" }, "Sign up")
], -1)
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "flex flex-col w-full text-sage-500" }
const _hoisted_5 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-8 text-sm text-red-400",
  "data-testid": "error-message"
}
const _hoisted_7 = { class: "flex items-center justify-center text-sm" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Submit ")

import { computed, ref } from 'vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInputComponent from '../TextInputComponent.vue';
import { UserRole } from '@/models/UserRoles';
import DropdownComponent from '../DropdownComponent.vue';
import { DropdownOptions } from '../../models/Forms/FormOptions';
import Icon from '../icon/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationComponent',
  props: {
  error: {
    type: String
  }
},
  emits: ['register'],
  setup(__props, { emit }) {

const props = __props




const firstName = ref('');
const lastName = ref('');
const role = ref(UserRole.GUEST);
const code = ref('');

const dropdownValues: DropdownOptions[] = [
  { label: 'Student', value: UserRole.STUDENT },
  { label: 'Instructor', value: UserRole.INSTRUCTOR },
  { label: 'Administrator', value: UserRole.ADMIN }
];

const isValid = computed(() => {
  return (
    firstName.value &&
    lastName.value &&
    role.value !== UserRole.GUEST &&
    code.value
  );
});

const codeHelperText = computed(() => {
  let returnValue = '';
  switch (role.value) {
    case UserRole.STUDENT:
      returnValue = 'Enter your six digit class code';
      break;
    case UserRole.INSTRUCTOR:
      returnValue = 'Enter your six digit instructor access code';
      break;
    case UserRole.ADMIN:
      returnValue = 'Enter your six digit admin access code';
      break;
    default:
      returnValue = 'Enter your six digit access code';
      break;
  }
  return returnValue;
});

const codePlaceholder = computed(() => {
  let returnValue = '';
  switch (role.value) {
    case UserRole.STUDENT:
      returnValue = 'Class code';
      break;
    case UserRole.INSTRUCTOR:
      returnValue = 'Instructor access code';
      break;
    case UserRole.ADMIN:
      returnValue = 'Admin access code';
      break;
    default:
      returnValue = 'Access code';
      break;
  }
  return returnValue;
});

function register() {
  emit('register', {
    firstName: firstName.value,
    lastName: lastName.value,
    role: role.value,
    code: code.value
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    class: "login-form-body"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TextInputComponent, {
        helperText: "First name",
        placeholder: "First name",
        dataTestId: "first-name",
        value: firstName.value,
        class: "w-full ml-2",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (firstName.value = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TextInputComponent, {
        helperText: "Last name",
        placeholder: "Last name",
        dataTestId: "last-name",
        value: lastName.value,
        class: "w-full ml-2",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (lastName.value = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
        'mb-20': role.value === _unref(UserRole).GUEST,
        'mb-8': role.value !== _unref(UserRole).GUEST
      })
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(DropdownComponent, {
          class: "h-8 ml-2",
          errorText: "Select option",
          placeholder: "Select user role",
          required: true,
          values: dropdownValues,
          isClearable: false,
          modelValue: role.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((role).value = $event)),
          "data-cy": "role-select"
        }, null, 8, ["modelValue"])
      ])
    ], 2),
    (role.value !== _unref(UserRole).GUEST)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(TextInputComponent, {
            helperText: _unref(codeHelperText),
            placeholder: _unref(codePlaceholder),
            dataTestId: "code-input",
            value: code.value,
            class: "w-full ml-2",
            required: true,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (code.value = $event))
          }, null, 8, ["helperText", "placeholder", "value"])
        ]))
      : _createCommentVNode("", true),
    (props.error && props.error !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(props.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(ButtonComponent, {
        onClick: register,
        "data-testid": "submit-button",
        "color-type": "secondary",
        size: "large",
        "right-icon-value": _unref(Icon).ICON_FIELD_RIGHT,
        disabled: !_unref(isValid)
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["right-icon-value", "disabled"])
    ])
  ], 32))
}
}

})